// src/pages/PublicProfilePage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { api, mediaUrl } from '../config';
import Avatar from '../components/Avatar';
import './RoamSharePage.css'; // reuse styles
import './PublicProfilePage.css';

const PublicProfilePage = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [posts, setPosts] = useState([]);
  const { accessToken, isLoggedIn } = useAuth();
  const [likeStates, setLikeStates] = useState({});
  const [isFollowing, setIsFollowing] = useState(false);
  const [isLoggedInUser, setIsLoggedInUser] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportReason, setReportReason] = useState('');
  const [reportDetails, setReportDetails] = useState('');
  const [submittingReport, setSubmittingReport] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  
  useEffect(() => {
    let mounted = true;
  
    const run = async () => {
      try {
        // be forgiving if route ever gets an @username
        const cleanUsername =
          (username || '').startsWith('@') ? username.slice(1) : username;
  
        const res = await fetch(
          api.url(`/api/roam-share-posts/user/${encodeURIComponent(cleanUsername)}`),
          {
            headers: {
              Authorization: `Bearer ${accessToken}`, // ✅ REQUIRED
            },
          }
        );
  
        if (!res.ok) {
          if (mounted) setLoading(false);
          return;
        }
  
        const data = await res.json();
        if (!mounted) return;
  
        setProfile(data.profile);
        setPosts(data.posts || []);
        // Build like state from the single response (no extra requests)
        const ls = {};
        (data.posts || []).forEach((p) => {
          ls[p.post_id] = {
            liked: !!p.liked,
            count: Number.isInteger(p.likes) ? p.likes : 0,
          };
        });
        setLikeStates(ls);
      } catch  {
      } finally {
        if (mounted) setLoading(false);
      }
    };
  
    run();
    return () => {
      mounted = false;
    };
  }, [username, accessToken]);

  useEffect(() => {
    const checkFollowingStatus = async () => {
        if (!profile || !profile.user_id || !accessToken) return;
  
      try {
        const response = await axios.get( api.url(`/api/roam-share-posts/check-follow-status/${profile.user_id}`), {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        setIsFollowing(response.data.isFollowing);
        setIsLoggedInUser(response.data.isSelf);
      } catch  {
      }
    };
  
    checkFollowingStatus();
  }, [profile, accessToken]);
  
  const handleFollowToggle = async () => {
    
  
    try {
      if (isFollowing) {
        
        const res = await axios.post( api.url(`/api/roam-share-posts/unfollow`), {
          userId: profile.user_id
        }, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        
        setIsFollowing(false);
      } else {
       
        const res = await axios.post( api.url(`/api/roam-share-posts/follow`), {
          userId: profile.user_id
        }, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        
        setIsFollowing(true);
      }
    } catch {
     
    }
  };
  const handleReportUser = async () => {
    if (!reportReason) {
      alert('Please select a reason.');
      return;
    }
  
    try {
      setSubmittingReport(true);
  
      const response = await axios.post(
        api.url(`/api/roam-share-posts/user/${profile.username}/report`),
        {
          reason: reportReason,
          details: reportDetails
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );
  
      alert('Report submitted successfully.');
  
      setShowReportModal(false);
      setReportReason('');
      setReportDetails('');
    } catch (err) {
      alert(
        err?.response?.data?.error ||
        'Failed to submit report.'
      );
    } finally {
      setSubmittingReport(false);
    }
  };
  // Normalize any media path coming from backend into something mediaUrl can handle
const resolveMediaPath = (value) => {
  if (!value) return null;
  if (typeof value !== 'string') return null;

  // already absolute
  if (value.startsWith('http://') || value.startsWith('https://')) return value;

  // already has /uploads prefix
  if (value.startsWith('/uploads/')) return value;
  if (value.startsWith('uploads/')) return `/${value}`;

  // S3-style key like roam_share_posts/filename.jpg
  if (value.startsWith('roam_share_posts/')) {
    return `/uploads/${value}`;
  }

  // plain filename -> assume local uploads folder
  return `/uploads/roam_share_posts/${value}`;
};

  
  if (loading) return null;
  if (!profile) {
    return (
      <div className="roamshare-page">
        <div className="header">
          <div className="brand" onClick={() => navigate('/')}>
            <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
            <span className="brand-text">CUSTOM ROAM</span>
          </div>
          <div className="nav-links">
            <span onClick={() => navigate('/')}>Home</span>
            <span onClick={() => navigate('/roam-share')}>Roam Share</span>
            <span onClick={() => navigate('/my-itineraries')}>My Itineraries</span>
            <span className="notification-icon" onClick={() => navigate('/notifications')}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="bell-svg"
  >
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
  </svg>
</span>
            <span onClick={() => navigate('/profile')}>Profile</span>
          </div>
        </div>
        <div style={{ padding: 24 }}>User not found.</div>
      </div>
    );
  }

  return (
    <div className="roamshare-page">
      <div className="header">
        <div className="brand" onClick={() => navigate('/')}>
          <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
          <span className="brand-text">CUSTOM ROAM</span>
        </div>
        <div className="nav-links">
          <span onClick={() => navigate('/')}>Home</span>
          <span onClick={() => navigate('/roam-share')}>Roam Share</span>
          <span onClick={() => navigate('/my-itineraries')}>My Itineraries</span>
          <span className="notification-icon" onClick={() => navigate('/notifications')}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="bell-svg"
  >
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
  </svg>
</span>
          <span onClick={() => navigate('/profile')}>Profile</span>
        </div>
      </div>

      {/* Public profile header */}
      <div className="public-profile-header">
      {!isLoggedInUser && (
    <div className="public-profile-menu-wrapper">
      <button
        type="button"
        className="public-profile-menu-button"
        aria-label="Profile options"
        aria-expanded={showProfileMenu}
        onClick={() => setShowProfileMenu((current) => !current)}
      >
        <span />
        <span />
        <span />
      </button>

      {showProfileMenu && (
        <div className="public-profile-menu-dropdown">
          <button
            type="button"
            className="public-profile-report-option"
            onClick={() => {
              setShowProfileMenu(false);
              setShowReportModal(true);
            }}
          >
            Report User
          </button>
        </div>
      )}
    </div>
  )}
      <Avatar
  src={profile?.profile_picture ? mediaUrl(profile.profile_picture) : undefined}
  alt={profile?.username || 'User'}
  size={96}
  className="avatar"
/>

<div className="username">
  @{profile.username}

  {!isLoggedInUser && (
    <button
      onClick={handleFollowToggle}
      className="follow-btn"
    >
      {isFollowing ? 'Unfollow' : 'Follow'}
    </button>
  )}
</div>
       {profile.bio && <div className="bio">{profile.bio}</div>}
       <div className="follower-stats">
       <span>{profile.follower_count ?? 0} Followers</span>
       <span>{profile.following_count ?? 0} Following</span>

      </div>

      </div>
       <h2 className="public-profile-heading"> {profile.username}'s Posts </h2>
      {/* Posts grid (read-only) */}
      <div className="roamshare-post-grid" style={{ paddingTop: 12 }}>
        {posts.length === 0 ? (
          <p style={{ padding: 16 }}>No posts yet.</p>
        ) : (
          posts.map((post) => {
            const isVideo = post.post_type === 'video';

return (
  <div className="roam-post-card" key={post.post_id}>
    <div className="roam-post-header" style={{ padding: '10px 12px 0 12px' }}>
      <div className="roam-post-username">@{profile.username}</div>
    </div>

    {isVideo
      ? (() => {
          if (!post.video) return null;

          const rawVideoPath = post.video; // could be filename, key, or URL
          const resolvedPath = resolveMediaPath(rawVideoPath);
          if (!resolvedPath) return null;

          const videoUrl = `${mediaUrl(resolvedPath)}#t=0.5`;

          return (
            <div className="video-wrapper">
              <video
                className="roam-post-video"
                controls
                preload="metadata"
                src={videoUrl}
              >
                <source src={videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          );
        })()
      : (() => {
          let imagesArray = [];

          if (Array.isArray(post.images)) {
            imagesArray = post.images;
          } else if (typeof post.images === 'string') {
            try {
              const parsed = JSON.parse(post.images);
              if (Array.isArray(parsed)) {
                imagesArray = parsed;
              } else {
                // fallback for Postgres-style {"a.jpg","b.jpg"}
                imagesArray = post.images
                  .replace(/^\{|\}$/g, '')
                  .split(',')
                  .map((s) => s.trim().replace(/^"|"$/g, ''))
                  .filter(Boolean);
              }
            } catch {
              // same fallback if JSON.parse fails
              imagesArray = post.images
                .replace(/^\{|\}$/g, '')
                .split(',')
                .map((s) => s.trim().replace(/^"|"$/g, ''))
                .filter(Boolean);
            }
          }

          if (!imagesArray.length) {
            // helps debug if still empty
            console.log('No images for post on public profile:', post.post_id, post.images);
            return null;
          }

          const first = imagesArray[0];
          const resolved = resolveMediaPath(first);
          if (!resolved) return null;

          return (
            <img
              src={mediaUrl(resolved)}
              alt=""
              className="roam-post-image"
            />
          );
        })()}

                <div className="roam-post-like-section">
  <div
    className={`like-icon-wrapper ${likeStates[post.post_id]?.liked ? 'liked' : ''}`}
    onClick={async () => {
      if (!isLoggedIn) return;

      const prev = likeStates[post.post_id] || { liked: false, count: 0 };
      const newLikeState = !prev.liked;

      // optimistic UI
      setLikeStates((s) => ({
        ...s,
        [post.post_id]: {
          liked: newLikeState,
          count: newLikeState ? prev.count + 1 : Math.max(0, prev.count - 1),
        },
      }));

      try {
        await fetch( api.url(`/api/roam-share-posts/like/${post.post_id}`), {
          method: 'POST',
          headers: { Authorization: `Bearer ${accessToken}` },
        });
      } catch (err) {
        // revert on error
        setLikeStates((s) => ({ ...s, [post.post_id]: prev }));
        
      }
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width="28"
      height="28"
      className="like-icon"
    >
      <path
        d="M32 2C18 2 6 14 6 28c0 7.7 5.5 15.3 12 21.6 4.8 4.5 10 8.4 14 12.4 4-4 9.2-8 14-12.4C52.5 43.3 58 35.7 58 28 58 14 46 2 32 2z"
        fill={likeStates[post.post_id]?.liked ? '#56ffc7' : 'none'}
        stroke="#008080"
        strokeWidth="4"
      />
      <path
        d="M32 16c-5-6.5-14-5.5-14 4 0 5 5 10 11 15l3 2.5 3-2.5c6-5 11-10 11-15 0-9.5-9-10.5-14-4z"
        fill={likeStates[post.post_id]?.liked ? '#e63946' : 'none'}
        stroke="#e63946"
        strokeWidth="3"
      />
    </svg>
  </div>
  <div className="like-count">
    {likeStates[post.post_id]?.count || 0}
  </div>
</div>

  <div className="roam-post-footer" style={{ padding: '8px 12px 12px 12px' }}>
  <p className="roam-post-location">📍 {post.location}</p>
      <p className="roam-post-caption">{post.content}</p>
    </div>
    </div>
   );
   })
   )}
</div>
{showReportModal && (
  <div
    className="report-modal-overlay"
    onClick={() => setShowReportModal(false)}
  >
    <div
      className="report-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <h3>Report User</h3>

      <select
        value={reportReason}
        onChange={(e) => setReportReason(e.target.value)}
      >
        <option value="">Select a reason</option>
        <option value="spam">Spam</option>
        <option value="harassment">Harassment</option>
        <option value="hate_or_abuse">Hate or abusive behavior</option>
        <option value="impersonation">Impersonation</option>
        <option value="inappropriate_content">Inappropriate content</option>
        <option value="fraud_or_scam">Fraud or scam</option>
        <option value="other">Other</option>
      </select>

      <textarea
        placeholder="Additional details (optional)"
        value={reportDetails}
        onChange={(e) => setReportDetails(e.target.value)}
        maxLength={500}
      />

      <div className="report-modal-actions">
        <button
          className="cancel-report-btn"
          onClick={() => setShowReportModal(false)}
        >
          Cancel
        </button>

        <button
          className="submit-report-btn"
          disabled={submittingReport}
          onClick={handleReportUser}
        >
          {submittingReport
            ? 'Submitting...'
            : 'Submit Report'}
        </button>
      </div>
    </div>
  </div>
)}
 </div>
  );
};

export default PublicProfilePage;
